import LinearProgress, {
  LinearProgressProps,
} from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
import React, { FunctionComponent } from 'react';

const BorderLinearProgress = withStyles(theme => ({
  root: {
    height: 10,
    backgroundColor: 'white',
  },
  barColorPrimary: {
    backgroundColor: theme.palette.secondary.main,
  },
  barColorSecondary: {
    backgroundColor: '#F3AD3C',
  },
}))(LinearProgress);

enum colorEnum {
  weak = 'secondary',
  medium = 'secondary',
  strong = 'primary',
}

const PasswordProgressEnum = {
  weak: {
    value: 40,
    color: colorEnum.weak,
  },
  medium: {
    value: 70,
    color: colorEnum.medium,
  },
  strong: {
    value: 95,
    color: colorEnum.strong,
  },
};

interface BarProps extends LinearProgressProps {
  value: number;
  color?: colorEnum;
}

// the branches will be replaced with better validation logic once there is a spec
const getProgressBar = (textValue: string): BarProps => {
  if (textValue.length < 3) {
    return PasswordProgressEnum.weak;
  }

  if (textValue.length < 6) {
    return PasswordProgressEnum.medium;
  }

  return PasswordProgressEnum.strong;
};

interface ProgressBarProps extends LinearProgressProps {
  value?: number;
  textValue?: string;
}

const ProgressBar: FunctionComponent<ProgressBarProps> = props => {
  const { textValue = '' } = props;
  const { color, value } = getProgressBar(textValue);
  const variant = !textValue.length ? 'indeterminate' : 'determinate';

  return (
    <div>
      <BorderLinearProgress
        variant={variant}
        color={color}
        value={props.value || value}
      />
    </div>
  );
};

export default ProgressBar;
